const wowApp = require('angular').module('wowApp.shop');

wowApp.service('GoogleCaptchaService', ['$q', 'ResourceInjector', 'SettingsService', 'Restangular', require('./googlecaptcha-service')]);
wowApp.service('GoogleCaptchaV3Service', ['$q', 'ResourceInjector', 'SettingsService', 'Restangular', require('./googlecaptcha-v3-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/googlecaptcha/index.js
 **/